import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, FormControl, InputLabel, Select, MenuItem,
  TextField, Box, Alert, CircularProgress
} from '@mui/material';
import { useAuth } from '../components/AuthContext';
import { API_BASE_URL } from '../components/api.js';

const ModalRegistrarFalta = ({ aberto, onFechar, linha, listaFaltas, onSalvar }) => {
  const { authenticatedFetch } = useAuth();

  const [faltaSelecionada, setFaltaSelecionada] = useState('');
  const [observacaoFalta, setObservacaoFalta] = useState('');
  const [dePeriodo, setDePeriodo] = useState(false);
  const [verificando, setVerificando] = useState(false);

  const extrairObservacaoFalta = (observacaoCompleta) => {
    if (!observacaoCompleta) return '';
    const match = observacaoCompleta.match(/\*(.*?)\*/);
    return match ? match[1].trim() : '';
  };

  // Ao abrir o modal, carrega dados e verifica se é de período
  useEffect(() => {
    if (aberto && linha) {
      const faltaId = linha.falta_id || '';
      setFaltaSelecionada(faltaId);
      setObservacaoFalta(extrairObservacaoFalta(linha.observacao));
      setDePeriodo(false);

      // Só verifica se tem falta lançada
      if (faltaId) {
        const underscoreIdx = linha.id.indexOf('_');
        const funcionario_id = linha.id.substring(0, underscoreIdx);
        const data = linha.id.substring(underscoreIdx + 1);

        setVerificando(true);
        authenticatedFetch(
          `${API_BASE_URL}/api/ponto-falta-verificar-periodo/?funcionario_id=${funcionario_id}&data=${data}&falta_id=${faltaId}`
        )
          .then(res => res.json())
          .then(data => setDePeriodo(data.de_periodo ?? false))
          .catch(() => setDePeriodo(false))
          .finally(() => setVerificando(false));
      }
    }
  }, [aberto, linha]);

  const handleSalvar = () => {
    onSalvar({
      data: linha.data,
      funcionario_id: linha.id.split('_')[0],
      falta_id: faltaSelecionada || null,
      observacao_falta: observacaoFalta.trim(),
    });
    handleFechar();
  };

  const handleFechar = () => {
    setFaltaSelecionada('');
    setObservacaoFalta('');
    setDePeriodo(false);
    onFechar();
  };

  const handleFaltaChange = (e) => {
    const novaFalta = e.target.value;
    setFaltaSelecionada(novaFalta);
    if (novaFalta === '') setObservacaoFalta('');
  };

  return (
    <Dialog open={aberto} onClose={handleFechar} maxWidth="sm" fullWidth>
      <DialogTitle>Registrar Falta</DialogTitle>

      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>

          {verificando && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} />
              <span style={{ fontSize: '0.85rem', color: '#666' }}>Verificando...</span>
            </Box>
          )}

          {dePeriodo && (
            <Alert severity="warning">
              Esta falta é vinculada a um período. Para editar ou remover, acesse a tela de <strong>Períodos</strong>.
            </Alert>
          )}

          <FormControl fullWidth disabled={dePeriodo}>
            <InputLabel>Tipo de Falta</InputLabel>
            <Select
              value={faltaSelecionada}
              label="Tipo de Falta"
              onChange={handleFaltaChange}
            >
              <MenuItem value=""><em>Nenhuma</em></MenuItem>
              {listaFaltas.map((falta) => (
                <MenuItem key={falta.falta_id} value={falta.falta_id}>
                  {falta.falta_nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            label="Observação"
            multiline rows={4} fullWidth
            value={observacaoFalta}
            onChange={(e) => setObservacaoFalta(e.target.value)}
            placeholder="Digite uma observação sobre a falta..."
            disabled={faltaSelecionada === '' || dePeriodo}
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleFechar} color="secondary">Cancelar</Button>
        <Button
          onClick={handleSalvar}
          variant="contained"
          color="primary"
          disabled={dePeriodo || verificando}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalRegistrarFalta;